import React, { ChangeEventHandler, HTMLInputTypeAttribute, ReactNode } from 'react';
import {
  TextInput as MantineTextInput,
  type MantineSize,
  MantineStyleProps,
  type TextInputProps,
} from '@mantine/core';
import textInputClasses from './TextInput.module.css';

type Props = {
  id?: string;
  required?: boolean;
  withAsterisk?: boolean;
  label?: string;
  description?: ReactNode;
  inputWrapperOrder?: TextInputProps['inputWrapperOrder'];
  placeholder?: string;
  disabled?: boolean;
  name?: string;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  type?: HTMLInputTypeAttribute;
  value?: string | readonly string[] | number | undefined;
  error?: React.ReactNode;
  rightSection?: ReactNode;
  autoFocus?: boolean;
  inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
  autoComplete?: string;
  size?: MantineSize;
  styles?: TextInputProps['styles'];
} & MantineStyleProps;

export default function TextInput({
  id,
  required,
  withAsterisk,
  label,
  placeholder,
  disabled,
  name,
  onChange,
  type,
  value,
  error,
  rightSection,
  autoFocus,
  inputMode,
  autoComplete,
  ...props
}: Props) {
  return (
    <MantineTextInput
      id={id}
      required={required}
      withAsterisk={withAsterisk}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      name={name}
      onChange={onChange}
      classNames={textInputClasses}
      type={type}
      value={value}
      error={error}
      rightSection={rightSection}
      autoFocus={autoFocus}
      inputMode={inputMode}
      autoComplete={autoComplete}
      {...props}
    />
  );
}
